import React from "react";
import { Wrapper } from "../../../constants/common/StyledGlobalConstants";
import { styled } from "styled-components";
import SkeletonLoader from "../common/SkeletonLoader";
import { Line } from "@vds/lines";
import propTypes from "prop-types";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";

const { TABLET } = DEVICE_BREAKPOINTS;

const HeaderText = styled.div`
  color: #000;
  font-family: neue-haas-grotesk-text;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin: 0;
  word-break: break-word;
  display: -webkit-box;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px 0;
`;

const MobileSkeletonLoader = ({ width }) => {
  const headerList = ["Service #", "Appointment date/time", "Appointment location", "Contact", "Status"];

  return (
    <>
      <Wrapper gap="8px" margin="16px 16px">
        <Wrapper display="grid" gridTemplateColumns="30% 70%" gridColumnGap="32px" gridRowGap="8px" margin="8px 0">
          {headerList.map((header) => (
            <>
              <HeaderText>{header}</HeaderText>
              <SkeletonLoader width={width < TABLET ? "85%" : "93%"} height="1rem" />
            </>
          ))}
        </Wrapper>
        <SkeletonLoader width="100%" height="3rem" />
      </Wrapper>
      <Line type="secondary" />
      <Wrapper gap="8px" margin="0 16px">
        <Wrapper display="grid" gridTemplateColumns="30% 70%" gridColumnGap="32px" gridRowGap="8px" margin="8px 0">
          {headerList.map((header) => (
            <>
              <HeaderText>{header}</HeaderText>
              <SkeletonLoader width={width < TABLET ? "85%" : "93%"} height="1rem" />
            </>
          ))}
        </Wrapper>
        <SkeletonLoader width="100%" height="3rem" />
      </Wrapper>
    </>
  );
};

MobileSkeletonLoader.propTypes = {
  width: propTypes.number,
};

export default MobileSkeletonLoader;
